import { ProfileConditionCardProps } from "./types";
import './styles.scss';

const ProfileConditionCard = (props: ProfileConditionCardProps) => {
    return (
        <div className='__ProfileConditionCard __profile-card'>
            <img src={props.imageSrc} alt="" className='__ProfileConditionCard-image mb-2' />
            <h6 className='font_montserrat font-weight-semi-bold __title'>{props.title}</h6>
            <p>{props.children}</p>
        </div>
    )
}

export default ProfileConditionCard;